
export function mergeListeners (target, ...sources) {
  if (!(sources?.length)) return target
  if (!target) target = {}
  for (const source of sources) {
    for (const name in source) {
      const sourceListener = source[name]
      const targetListener = target[name]
      if (targetListener) {
        let listeners
        if (Array.isArray(targetListener)) {
          listeners = targetListener
        } else {
          listeners = [targetListener]
          target[name] = listeners
        }
        Array.prototype.push[Array.isArray(sourceListener) ? 'apply' : 'call'](listeners, sourceListener)
      } else {
        target[name] = sourceListener
      }
    }
  }
  return target
}

export function lookUpVm (el, filter) {
  for (let node = el; node; node = node.parentElement) {
    let vm = node.__vue__
    if (vm) {
      if (filter) {
        while (vm && !filter(vm)) {
          vm = vm.$parent
        }
      }
      return vm
    }
  }
  return null
}

export function isDef (v) {
  return v !== undefined && v !== null
}

const _toString = Object.prototype.toString

export function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

export function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

export function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const c = children[i]
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

export function object2query (params) {
  let query = ''
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      query += key + '=' + params[key] + '&'
    }
  }
  return encodeURI(query)
}
